import { actionTypes, AuthActionsType } from "./authTypes";

const __DEV_AL__ =
  process.env.REACT_APP_ENV_MODE === "development" &&
  process.env.REACT_APP_DEV_AUTOLOGIN !== "0" &&
  !(window as any).__DEV_NO_AUTOLOGIN__ &&
  !!process.env.REACT_APP_DEV_ACCESS_TOKEN;

const initialState: authStateType = {
  accessToken: window.localStorage.accessToken || null,
  refreshToken: window.localStorage.refreshToken || null,
  isAuth: __DEV_AL__ ? true : !!window.localStorage.refreshToken,
  tokenIsValid: false,
  phone: "",
  countryCode: "+7",
  phoneCodes: [
    {
      countryCode: "+7",
      name: "Russia",
    },
    {
      countryCode: "+380",
      name: "Ukraine",
    },
  ],
  isSigningUp: false,
  countriesList:
    //(window.localStorage.countriesList &&
    // JSON.parse(window.localStorage.countriesList)) ||
    [],
  citiesList:
    //(window.localStorage.citiesList &&
    // JSON.parse(window.localStorage.citiesList)) ||
    [],
  oneTimePassword: null,
  oneTimePasswordErr: false,
  oneTimePasswordAttemptsLeft: null,
  oneTimePasswordTimeToUnblock: null,
  systemBan: false,
  userDeleted: false,
  phoneErr: false,
  isPinCodeNeed: false,
  pinCodeAttemptsLeft: null,
  pinCodeErr: false,
  isFilling: false,
  isVerified: false,
  isWebCam: false,
  ticket: null,
  needRefresh: false,
  usedToken: "",
  systemBanReason: -1,
  fbToken: "",
  googleCode: "",
  isSigningUpByGoogle: false,
  isSigningUpByFb: false,
  confirmationToken: "",
  isOpenModalPhone: true,
  isRefreshing: false,
  firstRefresh: true,
  offline: false,
  isHideAuthHeader: false,
};

type authStateType = {
  tempBlocked?: boolean;
  tempBlockedTime?: string;
  accessToken: null | string;
  refreshToken: null | string;
  isAuth: boolean;
  tokenIsValid: boolean;
  phone: null | string;
  countryCode: string;
  phoneCodes: Array<phoneCodeType>;
  isSigningUp: boolean;
  countriesList: Array<countryOrCityType>;
  citiesList: Array<countryOrCityType>;
  oneTimePassword: null | string;
  oneTimePasswordErr: boolean;
  oneTimePasswordAttemptsLeft: null | number;
  oneTimePasswordTimeToUnblock: null | number;
  systemBan: boolean;
  systemBanReason: number;
  userDeleted: boolean;
  phoneErr: boolean;
  isPinCodeNeed: boolean;
  pinCodeAttemptsLeft: number | null;
  pinCodeErr: boolean;
  isFilling: boolean;
  isVerified: boolean;
  isWebCam: boolean;
  ticket: string | null;
  needRefresh: boolean;
  usedToken: string;
  fbToken: string;
  googleCode: string;
  isSigningUpByGoogle: boolean;
  isSigningUpByFb: boolean;
  isOpenModalPhone: boolean;
  confirmationToken: string;
  isRefreshing: boolean;
  firstRefresh: boolean;
  offline: boolean;
  isHideAuthHeader: boolean;
};

type phoneCodeType = {
  countryCode: string;
  name: string;
};

type countryOrCityType = {
  name: string;
  id: number;
};

const authReducer = (
  state = initialState,
  { type, payload }: AuthActionsType
):authStateType => {
  switch (type) {
    case actionTypes.SET_IS_AUTH:
      return {
        ...state,
        isAuth: __DEV_AL__ ? true : payload,
        refreshToken: window.localStorage.refreshToken,
        accessToken: window.localStorage.accessToken,
      };
    case actionTypes.SET_TOKENS:
      return {
        ...state,
        refreshToken: payload.refreshToken,
        accessToken: payload.accessToken,
      };
    case actionTypes.SET_TOKEN_IS_VALID:
      return {
        ...state,
        tokenIsValid: payload,
      };
    case actionTypes.SET_PHONE:
      return {
        ...state,
        phone: payload,
      };
    case actionTypes.SET_COUNTRY_CODE:
      return {
        ...state,
        countryCode: payload,
      };
    case actionTypes.SET_SIGNING_UP:
      return {
        ...state,
        isSigningUp: payload,
      };
    case actionTypes.SET_PASSWORD:
      return {
        ...state,
        oneTimePassword: payload,
      };
    case actionTypes.SET_PASSWORD_ERR:
      return {
        ...state,
        //@ts-ignore
        oneTimePasswordErr: payload.errStatus,
        //@ts-ignore
        oneTimePasswordAttemptsLeft: payload!.attemptsLeft,
        //@ts-ignore
        oneTimePasswordTimeToUnblock: payload!.timeLeftForUnblock,
      };
    case actionTypes.SET_SYSTEM_BAN:
      return {
        ...state,
        systemBan: payload.status,
        systemBanReason: payload.reason,
      };
    case actionTypes.SET_IS_TEMP_BLOCKED: 
      return {
        ...state,
        tempBlocked: payload.status,
        tempBlockedTime: payload.timeLeft,
      };
    case actionTypes.SET_PROFILE_DELETED:
      return {
        ...state,
        userDeleted: payload,
      };
    case actionTypes.SET_PHONE_ERR:
      return {
        ...state,
        phoneErr: payload,
      };
    case actionTypes.SET_IS_PINCODE_NEED:
      return {
        ...state,
        isPinCodeNeed: payload,
      };
    case actionTypes.SET_PINCODE_ERR:
      return {
        ...state,
        pinCodeErr: payload,
      };
    case actionTypes.SET_IS_FILLING:
      return {
        ...state,
        isFilling: payload,
      };
    case actionTypes.SET_IS_VERIFIED:
      return {
        ...state,
        isVerified: payload,
      };
    case actionTypes.RESET_ALL_AUTH:
      return {
        ...state,
        oneTimePassword: null,
        isSigningUp: false,
      };
    case actionTypes.SET_WEBCAM:
      return {
        ...state,
        isWebCam: payload,
      };
    case actionTypes.SET_COUNTRIES_LIST:
      return {
        ...state,
        countriesList: payload,
      };
    case actionTypes.SET_CITIES_LIST:
      return {
        ...state,
        citiesList: payload,
      };
    case actionTypes.SET_SOCKET:
      return {
        ...state,
        ticket: payload,
      };
    case actionTypes.SET_NEED_REFRESH:
      return {
        ...state,
        needRefresh: payload,
        tokenIsValid: !payload,
      };
    case actionTypes.SET_USED_TOKEN:
      return {
        ...state,
        usedToken: payload,
      };
    case actionTypes.SET_FB_TOKEN:
      return {
        ...state,
        fbToken: payload,
      };
    case actionTypes.SET_GOOGLE_CODE:
      return {
        ...state,
        googleCode: payload,
      };
    case actionTypes.SET_IS_SIGNING_UP_BY_FB:
      return {
        ...state,
        isSigningUpByFb: payload,
      };
    case actionTypes.SET_IS_SIGNING_UP_BY_GOOGLE:
      return {
        ...state,
        isSigningUpByGoogle: payload,
      };
    case actionTypes.SET_CONFIRMATION_TOKEN:
      return {
        ...state,
        confirmationToken: payload,
      };
    case actionTypes.SET_IS_OPEN_MODAL_PHONE:
      return {
        ...state,
        isOpenModalPhone: payload,
      };
    case actionTypes.SET_REFRESHING:
      return {
        ...state,
        isRefreshing: payload,
      };
    case actionTypes.FIRST_REFRESH:
      return {
        ...state,
        firstRefresh: payload,
      };
    case actionTypes.OFFLINE:
      return {
        ...state,
        offline: payload,
      };
    case actionTypes.SET_IS_HIDE_AUTH_HEADER:
      return {
        ...state,
        isHideAuthHeader: payload,
      };
    default:
      return state;
  }
};

export default authReducer;
